import React from "react";
import { Tooltip } from "@heroui/react";
import { Check, Loader2, Plus } from "lucide-react";
import { getCleanName } from "@/shared/utils/accountConfig";
import { useAddRecommendedAccount } from "./useAddRecommendedAccount";

const SimilarAccountActionButton = ({ account, className = "" }) => {
  const name = getCleanName(account?.company_name || "—");
  const { add, canAdd, isAdding: isCreating, isAdded: isComplete } = useAddRecommendedAccount(account);

  const createRecommendedAccount = (event) => {
    event.stopPropagation();
    add();
  };

  return (
    <Tooltip
      content={isComplete ? "Account research started" : "Add to accounts"}
      placement="top"
      className="bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 font-normal text-xs shadow-md border border-gray-100 dark:border-gray-700 px-3 py-1.5 rounded-lg capitalize"
    >
      <span className="inline-flex shrink-0">
        <button
          type="button"
          onClick={createRecommendedAccount}
          onKeyDown={(event) => event.stopPropagation()}
          disabled={!canAdd}
          aria-label={`${isComplete ? "Added" : "Add"} ${name} as an account`}
          className={"inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg border border-gray-200 dark:text-secondary-light transition-colors disabled:cursor-not-allowed disabled:opacity-50 shadow-[0px_1px_2px_0px_rgba(255,255,255,0.25)_inset]"}
        >
          {isCreating ? (
            <Loader2 size={14} className="animate-spin text-secondary" />
          ) : isComplete ? (
            <Check size={14} strokeWidth={2} className="text-success-500" />
          ) : (
            <Plus size={14} strokeWidth={2.5} className="text-gray-500" />
          )}
        </button>
      </span>
    </Tooltip>
  );
};

export default SimilarAccountActionButton;
